// extracted by mini-css-extract-plugin
module.exports = {"infoWrapper":"ClientEmergencyInfo_infoWrapper__309BE","itemTitle":"ClientEmergencyInfo_itemTitle__2mzH5","itemText":"ClientEmergencyInfo_itemText__181rL"};